module.exports = __webpack_public_path__ + "img/_01_4e8136b2f.png";